import { CarbonOperation } from 'src/app/shared/interfaces/carbon-operation';

export type TransferenceModalMode = 'success' | 'error';

export type TransferenceModalAction = 'clear' | 'consult' | 'retry' | 'dismiss';

export interface TransferenceResultModalViewModel {
  mode: TransferenceModalMode;
  heading: string;
  icon: string;
  iconTone: 'success' | 'warning' | 'danger';
  bodyText: string;
  operationCode?: string;
}

const DEFAULT_ERROR_MESSAGE =
  'Não foi possível concluir a transferência. Verifique os dados e tente novamente ou entre em contato com o suporte.';

const SUCCESS_BODY = 'Transferência dos créditos foi realizada com sucesso.';

export function buildTransferenceResultModalViewModel(
  data: CarbonOperation | string,
): TransferenceResultModalViewModel {
  if (typeof data === 'string') {
    return {
      mode: 'error',
      heading: 'Erro!',
      icon: 'error',
      iconTone: 'danger',
      bodyText: data || DEFAULT_ERROR_MESSAGE,
    };
  }

  if (data.statusCode === 'OP_REJEITADA') {
    return {
      mode: 'error',
      heading: 'Erro!',
      icon: 'error',
      iconTone: 'danger',
      bodyText: DEFAULT_ERROR_MESSAGE,
    };
  }

  const isError =
    (data.statusCode == null && !data.operationCode)
    || (data.statusCode != null && Number(data.statusCode) === 0);

  if (isError) {
    return {
      mode: 'error',
      heading: 'Erro!',
      icon: 'error',
      iconTone: 'danger',
      bodyText: DEFAULT_ERROR_MESSAGE,
    };
  }

  return {
    mode: 'success',
    heading: 'Sucesso!',
    icon: 'check_circle',
    iconTone: 'success',
    bodyText: SUCCESS_BODY,
    operationCode: data.operationCode,
  };
}
